// Module
var code = `<ng-form name="\$ctrl.form">
<loan-automatic-transfer
  customer-id="\$ctrl.customerId"
  automatic-transfer="\$ctrl.loan.automaticTransferAgreement">
</loan-automatic-transfer>

<div class="flex-end buttons">
  <button type="button"
          class="btn btn-warning"
          ng-click="\$ctrl.redirectBack()">
    Cancel
  </button>

  <button type="submit"
          class="btn btn-primary"
          ng-click="\$ctrl.save()"
          ng-disabled="\$ctrl.form.\$invalid">
    Save
  </button>
</div>
</ng-form>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/edit/customer-loans-edit-automatic-transfer.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;